import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deleteMedicalId } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import ExperianContext from '../../../../ExperianContext';

const MedicalIds = ({ title, data }) => {
  const [medicalIdToDelete, setMedicalIdToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteMedicalId(clientId, subscriberId, medicalIdToDelete.Label));
    setMedicalIdToDelete(null);
  }, [clientId, subscriberId, medicalIdToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(medicalId => (
              <DataItem key={medicalId.Label}>
                <DeleteIcon onClick={() => setMedicalIdToDelete(medicalId)} />
                <DataItemText>{medicalId.MedicalId}</DataItemText>
              </DataItem>
            ))}
          </ItemContent>
        </div>
        {!!medicalIdToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setMedicalIdToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            Medical Id {medicalIdToDelete.MedicalId}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default MedicalIds;
